import { inmunetApi } from '../../../api';

export const getDatosGenerales = async() => {

    try {

        const { data } = await inmunetApi.get('/usuario');

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.usuario;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const updateDatosGenerales = async({ data: usuario }) => {

    try {

        let formData = new FormData();
        Object.keys(usuario).forEach(field => {
            formData.append(field, usuario[field]);
        });

        const { data } = await inmunetApi.put('/usuario', formData);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al actualizar datos';

        return data.usuario;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al actualizar datos');
        }

    }

};

export const updateCedulas = async({ data: cedulas }) => {

    try {

        let formData = new FormData();
        Object.keys(cedulas).forEach(field => {
            formData.append(field, cedulas[field]);
        });

        const { data } = await inmunetApi.put('/usuario/cedulas', formData);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al procesar archivo';

        return data.usuario;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error(error);
        }

    }

};